<template>
    <div class="form-builder-input" v-if="question" :rel="question.id">
        <input
            v-if="fieldType === 'line'"
            :readonly="readOnly"
            :placeholder="question.placeholder !== null ? question.placeholder[locale] : ''"
            class="form-control"
            type="text"
            v-model="value"
            v-mask="question.mask_field !== null ? masks[question.mask_field] : ''"
            :required="required !== undefined ? required : question.is_required"
            :id="id"
        />

        <input
            v-if="fieldType === 'cpf'"
            :placeholder="question.placeholder !== null ? question.placeholder[locale] : ''"
            :readonly="readOnly"
            class="form-control"
            type="tel"
            v-model="value"
            v-mask="masks.CPF"
            :required="required !== undefined ? required : question.is_required"
        />

        <input
            v-if="fieldType === 'cep'"
            :placeholder="question.placeholder !== null ? question.placeholder[locale] : ''"
            :readonly="readOnly"
            class="form-control"
            type="tel"
            v-model="value"
            v-mask="masks.CEP"
            :required="required !== undefined ? required : question.is_required"
            :id="id"
        />

        <input
            v-if="fieldType === 'number'"
            :placeholder="question.placeholder !== null ? question.placeholder[locale] : ''"
            :readonly="readOnly"
            class="form-control"
            type="number"
            min="0"
            v-model="value"
            :required="required !== undefined ? required : question.is_required"
            :id="id"
        />

        <textarea
            v-if="fieldType === 'text'"
            :placeholder="question.placeholder !== null ? question.placeholder[locale] : ''"
            :readonly="readOnly"
            class="form-control"
            v-model="value"
            :required="required !== undefined ? required : question.is_required"
            :id="id"
        ></textarea>

        <b-form-select
            v-if="fieldType === 'choice'"
            :readonly="readOnly"
            v-model="value"
            :options="options"
            :required="required !== undefined ? required : question.is_required"
            :id="id"
        >
            <template v-if="question.placeholder !== null" #first>
                <b-form-select-option value="" v-text="placeholder"></b-form-select-option>
            </template>
        </b-form-select>

        <b-form-checkbox-group
            v-if="fieldType === 'multiple_choice'"
            :disabled="readOnly"
            v-model="value"
            :value-field="'value'"
            :name="'question-checkbox-' + question.id"
            :options="Array.from(options)"
            :required="required !== undefined ? required : question.is_required"
            :class="inputClass"
            :id="id"
            stacked
        ></b-form-checkbox-group>

        <datetime-picker
            v-if="fieldType === 'date'"
            :id="id"
            v-model="value"
            :readonly="readOnly"
            :initial-value="value"
            :hide-time="true"
            :required="required !== undefined ? required : question.is_required"
        ></datetime-picker>

        <datetime-picker
            v-if="fieldType === 'datetime'"
            :id="id"
            v-model="value"
            :readonly="readOnly"
            :initial-value="value"
            :hide-time="false"
            :required="required !== undefined ? required : question.is_required"
        ></datetime-picker>

        <div
            v-if="fieldType === 'boolean'"
            :disabled="readOnly"
            class="d-inline-flex justify-content-between align-items-center"
        >
            <b-form-radio-group :id="id" v-model="value" :name="'checkbox-' + question.id">
                <b-form-radio :value="true" :id="id + '-1'">{{ $lang.get("common.Yes") }}</b-form-radio>
                <b-form-radio :value="false">{{ $lang.get("common.No") }}</b-form-radio>
            </b-form-radio-group>
        </div>
    </div>
</template>

<script>
import Masks from "../services/Masks";
export default {
    props: [
        "id",
        "initialValue",
        "question",
        "readOnly",
        "locale",
        "depends",
        "title",
        "placeholder",
        "options",
        "inputClass",
        "type",
        "required",
    ],

    data: () => {
        return {
            value: null,
            masks: Masks,
            questionTranslated: [],
            answers: [],
            fieldType: "line",
        };
    },

    beforeMount() {
        this.fieldType = this.type !== undefined ? this.type : this.question.field_type;
    },

    mounted: function () {
        if (this.initialValue) {
            this.value = this.initialValue;
            return;
        }

        if (this.question.default_value !== null) {
            this.value = this.question.default_value;
        }
    },

    watch: {
        value: function (newValue) {
            this.$emit("input", newValue);
        },
    },

    methods: {
        toggleInput: function (id) {
            document.getElementById(id).click();
        },

        decodeHTMLEntities(str) {
            var element = document.createElement("div");

            if (str && typeof str === "string") {
                str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, "");
                str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, "");
                element.innerHTML = str;
                str = element.textContent;
                element.textContent = "";
            }

            return str;
        },

        showTitleMultipleAnswers(question) {
            return question.metadata.answers["value"];
        },

        translateFields(text) {
            if (this.locale === undefined) {
                return text;
            }

            return text[this.locale];
        },
    },
};
</script>
